import React, {
    KeyboardEventHandler, MutableRefObject, useCallback
} from 'react';
import {BoxProps} from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField/TextField';
import NumberFormat, {
    NumberFormatProps, NumberFormatValues
} from 'react-number-format';

import {StackProps} from '../../layout/layout.styled';
import {FormControl} from '../form-control/form-control.styles';

export type YearInputFormControlProps = {
    labelText: string
    'data-testid'?: string
    stackProps?: StackProps
    inputFieldProps?: NumberFormatProps
    labelProps?: BoxProps
    onEnterKey?: KeyboardEventHandler
    inputRef?: MutableRefObject<any>
    onChange?: (e: { target: { value?: number } }) => any
}

export const YearInputFormControl = ({
    'data-testid': dataTestId = 'YearInputFormControl',
    onEnterKey,
    labelText,
    inputFieldProps,
    labelProps,
    stackProps,
    inputRef,
    onChange
}: YearInputFormControlProps) => {
    const handleKeyPress: KeyboardEventHandler = (event) => {
        if (!onEnterKey) return;

        if (event.key === 'Enter') {
            event.preventDefault();
            onEnterKey(event);
        }
    };

    const handleValueChange = (values: NumberFormatValues) => {
        onChange && onChange({ target: { value: values.floatValue } });
    };

    const CustomInput = useCallback((props) => <TextField
        {...props}
        inputRef={inputRef}
        variant={'outlined'}/>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

    return (
        <FormControl
            data-testid={dataTestId}
            labelText={labelText}
            labelProps={labelProps}
            {...stackProps}
        >
            <NumberFormat
                onValueChange={handleValueChange}
                customInput={CustomInput}
                format="####"
                mask={['_', '_', '_', '_']}
                onKeyPress={handleKeyPress}
                {...inputFieldProps}
            />
        </FormControl>
    );
};
